"use client";

import dynamic from "next/dynamic";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Pages from "src/constants/pages";
const Loading = dynamic(() => import("./Loading"));
import Wrapper from "src/components/layout/wrapper";
import { useGetUserProfile } from "src/services/auth";
import MainCard from "src/components/common/main-card";
const WalletListItems = dynamic(() => import("./WalletListItems"));

export default function Content() {
    const { data, isLoading } = useGetUserProfile();
    const credits = data?.value?.credits || [];

    return (
        <Wrapper title="کیف پول" toolbarHref={Pages.UserPanel} showToolbar>
            <MainCard shadow={3} sx={{ borderRadius: "8px", p: { xs: 1, md: 2 }, py: 1 }}>
                <Grid container alignItems="center" spacing={1.5}>
                    {isLoading ? (
                        <Loading />
                    ) : credits.length > 0 ? (
                        <Grid item xs={12}>
                            <WalletListItems credits={credits} />
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                sx={{
                                    textAlign: "center",
                                    color: "text.secondary",
                                    py: 4,
                                }}
                            >
                                هنوز هیچ کیف پولی برای شما ثبت نشده است.
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </MainCard>
        </Wrapper>
    );
};